export const INITIAL_VOLUME = 0.15;
// Ключ сменен 2026-10-27, как и у музыки (см. LOCAL_STORAGE_KEY_MUSIC_VOLUME):
// громкость звуков, выбранная раньше (вплоть до выключенной), один раз
// откатывается к INITIAL_VOLUME. Прежний ключ —
// LEGACY_LOCAL_STORAGE_KEY_VOLUME; при следующей такой смене завести новое
// имя, не возвращаться к старым
export const LOCAL_STORAGE_KEY_VOLUME = 'game_volume_v2';
// Больше не читается: значение под ним игра игнорирует
export const LEGACY_LOCAL_STORAGE_KEY_VOLUME = 'game_volume';

export const INITIAL_MUSIC_VOLUME = 0.7;
// Ключ сменен 2026-10-27 вместе с новой музыкой партии: громкость, которую
// игрок выбрал под прежнюю музыку (вплоть до выключенной), один раз
// откатывается к INITIAL_MUSIC_VOLUME — иначе новую музыку он мог бы не
// услышать вовсе. Прежний ключ — LEGACY_LOCAL_STORAGE_KEY_MUSIC_VOLUME; при
// следующей такой смене завести новое имя, не возвращаться к старым
export const LOCAL_STORAGE_KEY_MUSIC_VOLUME = 'game_music_volume_v2';
// Больше не читается: значение под ним игра игнорирует
export const LEGACY_LOCAL_STORAGE_KEY_MUSIC_VOLUME = 'game_music_volume';

// Громкость витрины главного меню: собственный ключ, отдельный от
// LOCAL_STORAGE_KEY_VOLUME обычных игр (см. MenuDemoGame/SoundManager).
//
// Стартует ровно с нуля — и это не про тишину, а про скорость: при нулевой
// громкости SoundManager вообще не грузит звуки (~32 МБ), и поле появляется
// быстрее. Уже после того, как поле отрисовано, витрина сама поднимает
// громкость до AUTO_DEMO_VOLUME и догружает звуки — но только если игрок
// никогда не трогал ползунок сам (см. demoVolumeStorage)
export const INITIAL_DEMO_VOLUME = 0;

// Громкость, которую витрина выставляет сама после загрузки поля: слышно, но
// тихо — она играет фоном, пока человек разглядывает меню
export const AUTO_DEMO_VOLUME = 0.1;

// Отдельный ключ-отметка «игрок сам выбрал громкость витрины». Без него
// автоподъем нельзя отличить от выбора игрока: значение громкости в
// localStorage пишется в обоих случаях (его читает SoundManager)
export const LOCAL_STORAGE_KEY_DEMO_VOLUME_CHOSEN = 'demo_game_volume_user_set';
export const LOCAL_STORAGE_KEY_DEMO_VOLUME = 'demo_game_volume';

// Событие окна: поле партии загружено и отрисовано (шлет GameContent). До него
// музыка партии не загружается, чтобы не отнимать канал у картинок и звуков
// поля (см. BackgroundMusic)
export const GAME_FIELD_READY_EVENT = 'gamefieldready';
